import dynamic from 'next/dynamic';
import { ComponentProps } from './component/index.types';

export const SearchForm = dynamic<ComponentProps>(() => import('./component/SearchForm'));
